import {FC, useCallback} from 'react';
import classnames from 'classnames';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import Icon from '../icon';
import {TopicFieldInfo, ubcProps} from '../../../services/pages/channel/channel.client';
import styles from './index.less';


export interface CardProps {
    className?: string;
    specInfo?: TopicFieldInfo;
    onClick?: () => void;
    ubcExt?: ubcProps;
}


const Card: FC<CardProps> = ({
    className,
    specInfo = {},
    ubcExt,
}) => {
    const {
        department = '',
        goodat = '',
        guahaostatus = '2',
        hospital = '',
        hospitalLevel = '',
        link = '',
        name = '',
        portrait = '',
        title = '',
        wenzhenstatus = '2',
    } = specInfo;

    const {
        page = '',
        value = '',
        pageSourceId,
        pageType = '',
        valueId,
        valueTitle = '',
    } = ubcExt as ubcProps;

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        () => {
            const urlParams = {
                linkUrl: link,
            };
            const logParams = {
                page: page,
                value: value,
                channelId: pageSourceId,
                pageType: pageType,
                moduleId: valueId,
                moduleName: valueTitle,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: valueId,
                    // eslint-disable-next-line camelcase
                    value_title: valueTitle,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [link, page, pageSourceId, pageType, value, valueId, valueTitle, navigateToUrl]
    );

    return (
        <div
            className={classnames(styles.container, className)}
            onClick={handleClick}
        >
            <div className={styles.imageWrap}>
                <img className={styles.image} src={portrait || 'https://med-fe.cdn.bcebos.com/content-external-channel/default_user_avatar.png'} alt="" />
            </div>
            <div className={styles.content}>
                <div className={styles.name}>
                    {name}
                    {
                        guahaostatus === '1' && (
                            <Icon
                                textValue="可挂号"
                                width="46px"
                                height="16px"
                                bgColor="rgba(0,0,0,0.05)"
                                fontColor="#858585"
                                borderColor="rgba(0,0,0,0.10)"
                            />
                        )
                    }
                    {
                        wenzhenstatus === '1' && (
                            <Icon
                                textValue="可咨询"
                                width="46px"
                                height="16px"
                                bgColor="rgba(0,0,0,0.05)"
                                fontColor="#858585"
                                borderColor="rgba(0,0,0,0.10)"
                            />
                        )
                    }
                </div>
                <div className={styles.desc}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.department}>{department}</span>
                </div>
                {
                    !!hospitalLevel && (
                        <div className={styles.hospital}>
                            <div>{hospital}</div>
                            <Icon textValue={hospitalLevel} width="32px" height="16px" />
                        </div>
                    )
                }
                <div className={styles.goodAt}>擅长：{goodat}</div>
            </div>
            <div className={styles.consult}>咨询</div>
        </div>
    );
};

export default Card;
